import React, { FunctionComponent, ReactNode } from 'react';
import List from '../../../components/list/List';

export interface ListRendererProps {
  children: ReactNode,
}

const ListRenderer: FunctionComponent<ListRendererProps> = ({ children }) => (
  <List>
    {children}
  </List>
);

export default ListRenderer;
